import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { Grid } from "@mui/material";
import { Container } from "@mui/system";
import ImagevitaleauVerrieresAntony from "../../src/assets/images/activites/Vitaleau-Montage-Generique.webp";
import carte from "../../src/assets/images/map.png";
import MetaMaster from "../components/utils/MetaMaster";
import { HeroInner } from "../stories/organisms/HeroInner";

export default function Contact() {
    return (
        <>
            <MetaMaster title={"Vital'eau - Contact"} />
            <HeroInner
                arianeItem={[
                    ["/", "Vital'Eau"],
                    ["/contact", "Nous contacter"],
                ]}
                imagesSwiper={[ImagevitaleauVerrieresAntony]}
            />
            {/* <HeroInnerIframe
                video={
                    "https://player.vimeo.com/progressive_redirect/playback/534374569/rendition/1080p/file.mp4?loc=external&log_user=0&signature=9d3650142e42fecceef6754023999d4ce77cc5681276de0b112d32b360b80d26"
                }
            /> */}
            <section className="section-show-pool-home section-contact-page" id="accueil-histoire">
                <Container maxWidth="xl">
                    <Grid container>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div>
                                <h1 className="accueil-histoire-titre h1-inner" data-title="Contact">
                                    Contact
                                </h1>
                                <p id="accueil-histoire-baseline"></p>
                                <p className="text-center">
                                    Vital’Eau se situe à la limite d’Antony (face au stade Georges Suant et au Parc Heller) dans la zone d’activités
                                    des Godets.
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                </Container>
                <br />
                <br />
                <br />
                <br />
                <Container maxWidth="xl">
                    <Grid container spacing={4}>
                        <Grid item lg={6} md={5} xs={12}>
                            <div className="contactCard">
                                <h3>VERRIERES-ANTONY</h3>
                                <p>
                                    <LocationOnOutlinedIcon />
                                    31 Rue des Petits Ruisseaux, 91 370 Verrières-le-Buisson
                                </p>
                                <a href={"mailto:verrieres@vitaleau.fr"} title="Adresse email de contact">
                                    <EmailOutlinedIcon />
                                    verrieres@vitaleau.fr
                                </a>
                                <a href={"tel:+33164470518"}>
                                    <PhoneOutlinedIcon />
                                    01 64 47 05 18
                                </a>
                                <a href={"tel:+33611731412"}>
                                    <SmartphoneIcon />
                                    06 11 73 14 12
                                </a>
                                <p>
                                    <AccessTimeIcon />
                                    Lundi au dimanche 10h à 21h
                                </p>
                            </div>
                        </Grid>
                        <Grid item lg={6} md={5} xs={12}>
                            <img src={carte} className="img-map-contact" alt="Carte vitaleau verrieres antony" loading="lazy" />
                        </Grid>
                    </Grid>
                </Container>
            </section>
        </>
    );
}
